import React, { useState } from 'react';
import styles from './EnableEncryptionSettings.module.css';
import { useSetEncryptionKey } from 'api/database/useEncryption';

const EnableEncryptionSettings = ({ setEncryptionSettings }) => {
  const [key, setKey] = useState('');
  
   const {
      loading,
      response,
      error,
      setEncryptionKey
    } = useSetEncryptionKey({
      encryption_key: key
    });

  const handleInputChange = (e) => {
    setKey(e.target.value);
  };

  const encrypt = () => {
    setEncryptionKey();
  }

  return (
    <div onClick={(e) => e.stopPropagation()} className={styles.enable_encryption_settings}>
      <span>Enter encryption key</span>
      <input
        type="text"
        placeholder="48 characters key"
        value={key}
        onChange={handleInputChange}
      />
      <div className={styles.actions}>
        <button onClick={() => setEncryptionSettings(false)}>Cancel</button>
        <button disabled={key.length != 48} onClick={()=> {encrypt(); setEncryptionSettings(false);}}>Proceed</button>
      </div>
    </div>
  );
};

export default EnableEncryptionSettings;
